"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.anthropicModelCards = exports.ANTHROPIC_MODEL_CARDS = exports.AnthropicThinkingMode = exports.AnthropicThinkingType = exports.AnthropicAiModel = void 0;
exports.getAnthropicModelCard = getAnthropicModelCard;
exports.supportsAnthropicReasoningValue = supportsAnthropicReasoningValue;
const model_card_1 = require("./model-card");
var AnthropicAiModel;
(function (AnthropicAiModel) {
    AnthropicAiModel["claude_opus_4_8"] = "claude-opus-4-8";
    AnthropicAiModel["claude_opus_4_6"] = "claude-opus-4-6";
    AnthropicAiModel["claude_sonnet_5"] = "claude-sonnet-5";
    AnthropicAiModel["claude_sonnet_4_6"] = "claude-sonnet-4-6";
    AnthropicAiModel["claude_haiku_4_5"] = "claude-haiku-4-5";
})(AnthropicAiModel || (exports.AnthropicAiModel = AnthropicAiModel = {}));
var AnthropicThinkingType;
(function (AnthropicThinkingType) {
    AnthropicThinkingType["disabled"] = "disabled";
    AnthropicThinkingType["enabled"] = "enabled";
})(AnthropicThinkingType || (exports.AnthropicThinkingType = AnthropicThinkingType = {}));
var AnthropicThinkingMode;
(function (AnthropicThinkingMode) {
    AnthropicThinkingMode["adaptive"] = "adaptive";
    AnthropicThinkingMode["manual"] = "manual";
})(AnthropicThinkingMode || (exports.AnthropicThinkingMode = AnthropicThinkingMode = {}));
function effort({ default: defaultValue }, ...supportedValues) {
    return {
        parameter: 'effort',
        supportedValues,
        defaultValue,
    };
}
function pricing(input, output) {
    return {
        currency: 'USD',
        unit: 'perMillionTokens',
        input,
        output,
    };
}
const ADAPTIVE_THINKING = {
    mode: AnthropicThinkingMode.adaptive,
    enabledByDefault: false,
    manualBudgetTokens: 'unsupported',
};
const ADAPTIVE_THINKING_WITH_DEPRECATED_MANUAL_BUDGET = {
    mode: AnthropicThinkingMode.adaptive,
    enabledByDefault: false,
    manualBudgetTokens: 'deprecated',
};
exports.ANTHROPIC_MODEL_CARDS = {
    [AnthropicAiModel.claude_opus_4_8]: {
        model: AnthropicAiModel.claude_opus_4_8,
        name: 'Claude Opus 4.8',
        provider: model_card_1.AiModelProvider.anthropic,
        reasoning: effort({ default: model_card_1.AiModelEffort.high }, model_card_1.AiModelEffort.low, model_card_1.AiModelEffort.medium, model_card_1.AiModelEffort.high, model_card_1.AiModelEffort.xhigh, model_card_1.AiModelEffort.max),
        thinking: ADAPTIVE_THINKING,
        standardTokenPricing: pricing(5, 25),
        contextWindowTokens: 1_000_000,
        maxOutputTokens: 128_000,
    },
    [AnthropicAiModel.claude_opus_4_6]: {
        model: AnthropicAiModel.claude_opus_4_6,
        name: 'Claude Opus 4.6',
        provider: model_card_1.AiModelProvider.anthropic,
        reasoning: effort({ default: model_card_1.AiModelEffort.high }, model_card_1.AiModelEffort.low, model_card_1.AiModelEffort.medium, model_card_1.AiModelEffort.high, model_card_1.AiModelEffort.max),
        thinking: ADAPTIVE_THINKING_WITH_DEPRECATED_MANUAL_BUDGET,
        standardTokenPricing: pricing(5, 25),
        contextWindowTokens: 1_000_000,
        maxOutputTokens: 128_000,
    },
    [AnthropicAiModel.claude_sonnet_5]: {
        model: AnthropicAiModel.claude_sonnet_5,
        name: 'Claude Sonnet 5',
        provider: model_card_1.AiModelProvider.anthropic,
        reasoning: effort({ default: model_card_1.AiModelEffort.high }, model_card_1.AiModelEffort.low, model_card_1.AiModelEffort.medium, model_card_1.AiModelEffort.high, model_card_1.AiModelEffort.xhigh, model_card_1.AiModelEffort.max),
        thinking: {
            ...ADAPTIVE_THINKING,
            enabledByDefault: true,
        },
        standardTokenPricing: pricing(3, 15),
        promotionalTokenPricing: {
            pricing: pricing(2, 10),
            through: '2026-08-31',
        },
        contextWindowTokens: 1_000_000,
        maxOutputTokens: 128_000,
    },
    [AnthropicAiModel.claude_sonnet_4_6]: {
        model: AnthropicAiModel.claude_sonnet_4_6,
        name: 'Claude Sonnet 4.6',
        provider: model_card_1.AiModelProvider.anthropic,
        reasoning: effort({ default: model_card_1.AiModelEffort.high }, model_card_1.AiModelEffort.low, model_card_1.AiModelEffort.medium, model_card_1.AiModelEffort.high, model_card_1.AiModelEffort.max),
        thinking: ADAPTIVE_THINKING_WITH_DEPRECATED_MANUAL_BUDGET,
        standardTokenPricing: pricing(3, 15),
        contextWindowTokens: 1_000_000,
        maxOutputTokens: 128_000,
    },
    [AnthropicAiModel.claude_haiku_4_5]: {
        model: AnthropicAiModel.claude_haiku_4_5,
        name: 'Claude Haiku 4.5',
        provider: model_card_1.AiModelProvider.anthropic,
        reasoning: {
            parameter: 'thinking.type',
            supportedValues: [AnthropicThinkingType.disabled, AnthropicThinkingType.enabled],
            defaultValue: AnthropicThinkingType.disabled,
        },
        thinking: {
            mode: AnthropicThinkingMode.manual,
            enabledByDefault: false,
            manualBudgetTokens: 'supported',
        },
        standardTokenPricing: pricing(1, 5),
        contextWindowTokens: 200_000,
        maxOutputTokens: 64_000,
    },
};
exports.anthropicModelCards = Object.values(exports.ANTHROPIC_MODEL_CARDS);
function getAnthropicModelCard(model) {
    return exports.ANTHROPIC_MODEL_CARDS[model];
}
function supportsAnthropicReasoningValue(model, value) {
    return getAnthropicModelCard(model).reasoning?.supportedValues.includes(value) ?? false;
}
//# sourceMappingURL=anthropic-model-cards.js.map